import {
  LodgingCardFields,
  LodgingEgdsRatingFragment,
  LodgingGalleryCarouselFragment,
  LodgingMediaItemFragment,
  PropertyFields,
  PropertyFieldsFragment,
} from 'src/common/__generated__/api';

export const mapLodgingCard = (lodgingCard: LodgingCardFields.Fragment): Partial<PropertyFieldsFragment> => {
  if (!lodgingCard) {
    return;
  }

  const productRating = lodgingCard.headingSection?.productRating as LodgingEgdsRatingFragment.EgdsIconRatingInlineFragment;

  return {
    id: lodgingCard.id,
    name: lodgingCard.headingSection?.heading,
    star: productRating?.rating,
    starRatingIcon: productRating?.icon?.id,
    imageGallery: mapLodgingGalleryCarousel(lodgingCard.mediaSection.gallery),
  };
};

export const mapMediaItem = (mediaItem: LodgingMediaItemFragment.Fragment): PropertyFields.Images => {
  if (!mediaItem) {
    return;
  }

  if (mediaItem.media.__typename === 'Image') {
    return {
      __typename: 'PropertyImage',
      image: {
        __typename: 'Image',
        url: mediaItem.media.url,
        description: mediaItem.media.description,
      },
    };
  }
};

export const mapLodgingGalleryCarousel = (gallery: LodgingGalleryCarouselFragment.Fragment): PropertyFields.ImageGallery => {
  if (!gallery) {
    return null;
  }

  return {
    __typename: 'PropertyImageGallery',
    images: gallery.media.map(mediaItem => mapMediaItem(mediaItem)),
  };
};
